import { Component, OnInit } from '@angular/core';
import { DashboardWidgetContent, DashboardWidgetLookup } from '@serengeti/serengeti-dashboard';

@DashboardWidgetLookup('WizardApiRegisteredComponent')
@Component({
  selector: 'app-wizard-api-registered',
  templateUrl: './wizard-api-registered.component.html',
  styleUrls: ['./wizard-api-registered.component.css']
})
export class WizardApiRegisteredComponent implements OnInit, DashboardWidgetContent {

  constructor() { }

  property(): boolean {
    return true;
  }

  configure(setting: any): void {
  }

  ngOnInit() {
  }

}
